import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import { productSelectorStyles } from "@insite/content-library/Components/ProductSelector";

import { css } from "styled-components";

productSelectorStyles.productImage = mergeToNew(productSelectorStyles.productImage, {
    width: "50px",
    css: css`
        flex-shrink: 0;
        img {
            max-height: 100%;
            max-width: 100%;
            height: auto;
        }
    `,
});
